import 'lazysizes';
//import 'src/_api_';
import 'src/utils/i18n';
//import 'src/utils/highlight';
import 'simplebar/src/simplebar.css';
//import 'mapbox-gl/dist/mapbox-gl.css';
import 'slick-carousel/slick/slick.css';
import 'react-image-lightbox/style.css';
import 'react-quill/dist/quill.snow.css';
import 'slick-carousel/slick/slick-theme.css';
//import 'lazysizes/plugins/attrchange/ls.attrchange';
//import 'lazysizes/plugins/object-fit/ls.object-fit';
//import 'lazysizes/plugins/parent-fit/ls.parent-fit';
//import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';


import { LicenseInfo } from '@material-ui/x-grid'
import { xgridConfig } from 'src/config'

import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

window.hljs = hljs;


LicenseInfo.setLicenseKey(
    xgridConfig.licenseKey
)
// ----------------------------------------------------------------------

ReactDOM.render(<App />, document.getElementById('root'));
